function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Guyfawkes = ({
  style,
  color,
  ...rest
}) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 397.8 240",
  style: {
    width: 50,
    height: 50,
    top: -6,
    ...style
  }
}, rest), /*#__PURE__*/React.createElement("path", {
  d: "M178.3,62.9c-1.5,0-3-0.6-4.2-1.7c-2.3-2.3-2.3-6.1,0-8.4l12.1-12.1c2.3-2.3,6.1-2.3,8.4,0 c2.3,2.3,2.3,6.1,0,8.4l-12.1,12.1C181.3,62.3,179.8,62.9,178.3,62.9z",
  fill: "#222223"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.6,162.8h107.8V99.9H253.6c-17.4,0-31.5,14.1-31.5,31.5C222.1,148.7,236.2,162.8,253.6,162.8z",
  fill: "#57565C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M323.2,99.9c-5.5,11.5-17.2,19.4-30.7,19.4h-28c4.7-11.4,16-19.4,29.1-19.4h-40c-13.2,0-24.5,8.1-29.2,19.7 c0,0,0,0.1-0.1,0.1c-0.2,0.5-0.4,0.9-0.5,1.4c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.4-0.3,0.9-0.4,1.3c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.4-0.2,0.8-0.3,1.2c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.4-0.2,0.8-0.2,1.2c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2 c0,0.2,0,0.3-0.1,0.5c0,0.4-0.1,0.8-0.1,1.2c0,0.2,0,0.3,0,0.5c0,0.6,0,1.1,0,1.7c0,17.4,14.1,31.5,31.5,31.5h107.8V99.9 L323.2,99.9L323.2,99.9z",
  fill: "#444346"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.8,39.2c-12.3,0-22.2,10-22.2,22.2v23.8c0,25.4-20.6,46-46,46h-58.4c-25.4,0-46-20.6-46-46 c0-20.2-13-37.3-31.2-43.5c0,0,0,0,0.1,0c-0.1,0-0.2,0-0.3-0.1c-2.1-0.7-4.3-1.3-6.5-1.7c-0.4-0.1-0.7-0.1-1.1-0.2 c-2.3-0.4-4.6-0.6-7-0.6c-57.1,0-105.4,37.6-121.5,89.4c-0.3,0.9-0.4,1.8-0.7,2.7h-0.1c-0.9,3-1.6,6-2.2,9.1 c-0.1,0.6-0.2,1.2-0.3,1.9c-0.6,3.1-1.1,6.3-1.5,9.5c-0.1,1-0.2,2.1-0.3,3.1c-0.3,3.8-0.6,7.7-0.6,11.6v0V212H383v-32v-17.2V61.5 C383,49.2,373,39.2,360.8,39.2z",
  fill: color
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,240h381.8c4.4,0,8-3.6,8-8v-32c0-4.4-3.6-8-8-8H8c-4.4,0-8,3.6-8,8v32C0,236.4,3.6,240,8,240L8,240z",
  fill: "#57565C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40,232v-32c0-4.4,3.6-8,8-8H8c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8h40C43.6,240,40,236.4,40,232L40,232z",
  fill: "#444346"
}), /*#__PURE__*/React.createElement("path", {
  d: "M231.7,69.2c4.7-4.7,4.7-12.3,0-17L183.1,3.5c-4.7-4.7-12.3-4.7-17,0c-4.7,4.7-4.7,12.3,0,17l48.7,48.7 C219.4,73.9,227,73.9,231.7,69.2L231.7,69.2z",
  fill: "#57565C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.8,52.2c4.7-4.7,4.7-12.3,0-17l17,17c4.7,4.7,4.7,12.3,0,17c-4.7,4.7-12.3,4.7-17,0l-17-17 C202.5,56.9,210.1,56.9,214.8,52.2L214.8,52.2z",
  fill: "#444346"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.9,98.4l1,0.6c7.6,4.2,15.2,8.4,22.8,12.6c0.9,0.4,1.4,1.3,1.3,2.2c-0.1,2.5,0,2.2-2.2,3.5 c-0.8,0.6-1.9,0.6-2.7,0.1c-7-3.9-14-7.8-21-11.7L81,105c0,0.3,0,0.5,0,0.8v35.8c0,1.2,0.7,2.3,1.8,2.9l23.6,13.3 c3.4,2,6.9,3.9,10.3,5.9c1.2,0.8,2.8,0.8,4,0c11.3-6.4,22.6-12.8,33.9-19.1c1.3-0.6,2.1-2,2.1-3.4c0-11.7,0-23.4,0-35.1 c0-0.4,0-0.7,0-1.2l-1.1,0.6l-32.1,17.8c-0.7,0.3-1.2,1-1.1,1.8c0,8.7,0,17.4,0,26.1v0.9c0,0.6-0.3,1.1-0.9,1.4l-1.7,0.9 c-0.5,0.3-1.2,0.3-1.8,0l-1.6-0.9c-0.6-0.2-1-0.8-0.9-1.4c0-0.2,0-0.5,0-0.7v-29.5c0-0.3,0-0.5,0-0.8c0-0.5,0.3-1,0.8-1.3l2.6-1.4 L153.5,99l1.1-0.6l-0.9-0.6l-32.9-17.1c-1.3-0.7-2.8-0.7-4.1,0c-11,5.8-21.9,11.4-32.9,17.1L82.9,98.4z",
  fill: "#FFFFFF"
}));

export default Guyfawkes;